import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import PrintIcon from "@mui/icons-material/Print";

interface Props {
  title: string; // "Monthly Summary" / "Summary"
  disabled: boolean;
  onPdf: () => void;
  onPrint: () => void;
}

/**
 * Actions for the FULL financial report (every period mode). Transaction
 * exports live on the ledger card instead, so the two never get mixed up.
 */
const ReportActionBar: React.FC<Props> = ({ title, disabled, onPdf, onPrint }) => (
  <Box display="flex" alignItems="center" flexWrap="wrap" gap={1} sx={{ mb: 1 }}>
    <Typography variant="subtitle1" fontWeight={700}>
      {title}
    </Typography>
    <Box display="flex" gap={1} flexWrap="wrap" sx={{ ml: "auto" }}>
      <Button variant="outlined" color="error" startIcon={<PictureAsPdfRoundedIcon />} disabled={disabled} onClick={onPdf}>
        Download Report PDF
      </Button>
      <Button variant="outlined" startIcon={<PrintIcon />} disabled={disabled} onClick={onPrint}>
        Print Report
      </Button>
    </Box>
  </Box>
);

export default ReportActionBar;
